export const contactObj={
    id:'contact',
    lightBg:true,
    lightText:true,
    topLine: 'Send me a message',
    mailID:'vignesh.mallya315@gmail.com',
    mobileNumber:'+91 7760466001',
    buttonLabel: 'Send',
    imgStart: true,
    img: require(`../../images/contact.svg`).default,
    alt: 'Contact',
    dark:true,
    primary:true,
    darkText:true,
}